import { useEffect, useState } from "react";
import { getAllIncidentsForEmployee, setSearchPopover }
  from "../incident.slice";
import { useAppDispatch } from "hooks/hooks";
import {
  Control,
  Controller,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormSetFocus,
  UseFormSetValue
} from "react-hook-form";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import { styles } from "../../../../components/Popover/popoverSelectStyle";
import { IIncidentSearch } from "../domain/IIncidentSearch";
import classes from "../../../../components/Popover/popover.module.scss";
import classesInc from "../styles/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IIncidentSearch>;
  control: Control<IIncidentSearch, any>;
  getValues: UseFormGetValues<IIncidentSearch>;
  setFocus: UseFormSetFocus<IIncidentSearch>;
  setValue: UseFormSetValue<IIncidentSearch>;
};

const SearchIncidentModal = (props: IProps) => {
  const dispatch = useAppDispatch();

  const { handleSubmit, control, setFocus, setValue, getValues }
    = props;

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>(
    [getValues("from") ? new Date(getValues("from")!) : null,
    getValues("to") ? new Date(getValues("to")!) : null]);

  const onSubmit = async (data: IIncidentSearch) => {
    try {
      close();
      dispatch(getAllIncidentsForEmployee(data));
    } catch (err) {
      console.error(err);
    }
  };

  const close = () => {
    dispatch(setSearchPopover({ isOpen: false }));
  };

  useEffect(() => {
    setFocus("employeeId");
  }, [setFocus]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`${classesInc.searchPopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>zaposleni</label>
          <Controller
            name="employeeId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <EmployeeSelect
                value={getValues("employeeId")}
                onChange={onChange}
                customStyles={styles.customStyleClassic} />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>saradnik</label>
          <Controller
            name="accompliceEmployeeId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <EmployeeSelect
                value={getValues("accompliceEmployeeId")}
                onChange={onChange}
                customStyles={styles.customStyleClassic} />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>incidenti od do</label>
          <div className="datepickerWrapper">
            <DatePicker
              selectsRange={true}
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              showMonthDropdown
              showYearDropdown
              onChange={(date: any) => {
                setDateRange([date[0], date[1]]);
                setValue("from", date[0] && FormatDateIso(date[0]));
                setValue("to", date[1] && FormatDateIso(date[1]));
              }}
              isClearable={true}
              className={`${classes.dateItem} ${classes.itemBorder}`}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>projekat</label>
          <Controller
            name="projectId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <ProjectSelect
                value={getValues("projectId")}
                onChange={onChange}
                customStyles={styles.customStyleClassic} />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchIncidentModal;
